import React from 'react';
import { Row } from '../../shared/utils';

function QuestionCard({handleInputChange, AnnexA, questionNumber, question, inputName }) {

  let borderColorClass = "border";
  


  return (
    <div className="bg-white rounded-sm p-4 mt-4 mx-2 border">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        {/* Question and Radio Buttons */}
        <div className="col-span-12 flex flex-col md:flex-row md:items-center">
          <p className='md:w-9/12'>
            <strong>Question {questionNumber}: </strong> 
            {question}
          </p>
          
          <div className="flex mt-2 md:mt-0 mx-2">
            <label className="cursor-pointer flex items-center mr-4">
              <input maxLength={800} value='Yes' type="radio" className="peer sr-only" name='response' />
              <span className="w-2.5 h-2.5 rounded-full bg-white ring-2 ring-gray-300 ring-offset-2 ring-offset-white transition-all hover:shadow peer-checked:ring-green-500 peer-checked:bg-green-500 mr-2"></span>
              Yes
            </label>
    
            <label className="cursor-pointer flex items-center">
              <input maxLength={800} value='No' type="radio" className="peer sr-only" name='response' />
              <span className="w-2.5 h-2.5 rounded-full bg-white ring-2 ring-gray-300 ring-offset-2 ring-offset-white transition-all hover:shadow peer-checked:ring-green-500 peer-checked:bg-green-500 mr-2"></span>
              No
            </label>
          </div>
        </div>
    
        {/* Additional Form Fields */}
        {/* {formData.response == 'Yes' && AnnexA && ( */}
        {AnnexA && (
        // {AnnexAA && AnnexA && (
          <div className="col-span-1 md:col-span-12 grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <div className="col-span-1 md:col-span-2">
              <strong> Annex A: </strong>
            </div>
            <div>
              <p className="font-medium text-gray-700 mb-1"> Name of Regulator/Authority: </p>
              <input maxLength={800} type="text" name='regulatorName' placeholder="Enter Name of Regulator/Authority" onChange={handleInputChange} className="w-full p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500" />
            </div>
            <div>
              <p className="font-medium text-gray-700 mb-1"> Nature of incident for affirmative response (“Incident”): </p>
              <input maxLength={800} type="text" name='incidentNature' placeholder="Enter Nature of incident for affirmative response (“Incident”)"   onChange={handleInputChange} className="w-full p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500" />
            </div>
            <div>
              <p className="block font-medium text-gray-700 mb-1"> Details of Incident: </p>
              <input maxLength={800} type="text"name='incidentDetails' placeholder="Enter Details of Incident" onChange={handleInputChange} className="w-full p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500" />
            </div>
            <div>
              <p className="block font-medium text-gray-700 mb-1"> Date of Incident: </p>
              <input maxLength={800} type="date"name='incidentDate' onChange={handleInputChange} className="w-full p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500" />
            </div>


            <div>
              <p className="font-medium text-gray-700 mb-1">Status of Incident: </p>
              <input maxLength={800} type="text" name='incidentStatus' placeholder="Enter Status of Incident" onChange={handleInputChange} className="w-full p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500" />
            </div>
            <div>
              <p className="font-medium text-gray-700 mb-1"> Penalty amount/No. of years of imprisonment: </p>
              <input maxLength={800} type="text" name='penaltyAmount' placeholder="Enter Penalty amount/No. of years of imprisonment" onChange={handleInputChange} className="w-full p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500" />
            </div>
            <div>
              <p className="block font-medium text-gray-700 mb-1"> Remedial measures taken if any: </p>
              <input maxLength={800} type="text"name='remedialMeasures' placeholder="Enter Remedial measures taken if any" onChange={handleInputChange} className="w-full p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500" />
            </div>
            <div>
              <p className="block font-medium text-gray-700 mb-1"> Progress of remedial measures: </p>
              <input maxLength={800} type="text" name='remedialProgress' placeholder="Enter Progress of remedial measures" onChange={handleInputChange} className="w-full p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500" />
            </div>
            <div className="col-span-1 md:col-span-2">
              <p className="font-medium text-gray-700 mb-1">Reasons that you still meet the Authority's fit and proper criteria set out despite the incident:</p>
              <textarea maxLength={800}
                name="reasons" rows="4"
                placeholder="Enter reasons that you still meet the Authority's fit and proper criteria set out despite the incident"
                className="w-full p-1.5 border-2 border-gray-300 bg-gray-100 focus:outline-none focus:border-green-500 rounded-md"
              ></textarea>
            </div>


          </div>
        )}
      </div>
    </div>
  );
}

export default QuestionCard;



//  <input maxLength={800} checked={SDD["6.12"]} style={{ accentdivor: 'green', width: 18, height: 18, marginLeft: '10px', marginRight: '4px' }} 
// type="radio" name="govtEntity" onClick={() => {setComplianceResults({ SDD: { ...SDD, ["6.12"]: true } }) }} /> Yes 
//  <input maxLength={800} checked={!SDD["6.12"]} style={{ accentdivor: 'green', width: 18, height: 18, marginLeft: '10px', marginRight: '4px' }} 
// type="radio" name="govtEntity" onClick={() => setComplianceResults({ SDD: { ...SDD, ["6.12"]: false } })} /> No 